import React, { Component } from "react";
import { IStore } from "@my-dld/reducers/store";
import { connect } from "react-redux";
import { HTRequest } from "./api/entities";

export interface IContext {
	request?: HTRequest;
}

export const defContext: IContext = {};

const Context = React.createContext( defContext );
export default Context;

class Wrapper extends Component<IContext> {
	render() {
		return (
			<Context.Provider value={ this.props }>
				{ this.props.children }
			</Context.Provider>
		);
	}
}

function mapStateToProps( state: IStore ) {
	return {
		...state.PropertyHandTakeOver,
	};
}

export const ContextWrapper = connect( mapStateToProps )( Wrapper );
